import { render, staticRenderFns } from "./MultiTableDiscountComp.vue?vue&type=template&id=67c75fef"
import script from "./MultiTableDiscountComp.vue?vue&type=script&lang=ts"
export * from "./MultiTableDiscountComp.vue?vue&type=script&lang=ts"
import style0 from "./MultiTableDiscountComp.vue?vue&type=style&index=0&id=67c75fef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports